<template>
  <div style="padding: 0 !important;">
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Ficha de partido</v-toolbar-title>
      <v-btn color="blue-grey-lighten-4" absolute right @click="goBack">Volver</v-btn>
    </v-toolbar>
    <div v-if="loading">
        <v-flex offset-xs5 pa-5>
          <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
        </v-flex>
      </div>
    <v-content v-else class="body-content">
      <div class="title">
        <h2 class="clubs-title">{{ this.partido.clubLocal }} (Local) vs {{ this.partido.clubVisitor }} (Visitante)</h2>
      </div>
      <HeaderFichaPartido @activateEditPopUp="handleEditCard" :partido="partido">
      </HeaderFichaPartido>
      <EditCampoPartido
      v-if="editMode"
      :editMode="editMode"
      :type="editType"
      :title="editTitle"
      :time="time"
      :date="date"
      :partidoId="partidoId"
      :categoria="partido.categoriaDePartido.description"
      :directoresAsignados="partido.directores"
      :participantesLpfAsignados="partido.participantesLpf"
      @cancelEditMode="switchEditMode"
      >
      </EditCampoPartido>
      <PartidoDataCard
      v-if="this.$store.state.permissions.canViewComentarioPrePartido"
      classType="card-comentarios"
      title="Comentarios pre-partido"
      cardType="comentarios"
      :localData="partido.localLogo"
      :visitorData="partido.visitorLogo"
      :partidoId="partidoId"
      :data="[]"
      @createComentarioPrePartido="handleNewComentarioPrePartido"
      @ViewComentarioPrePartido="handleViewComentarioPrePartido"
      >
    </PartidoDataCard>
      <PartidoDataCard
      classType="card-container"
      title="Informes"
      cardType="informes"
      :data="informes"
      >
    </PartidoDataCard>
    <PartidoDataCard
      v-if="this.$store.state.permissions.canViewAdjuntosFichaPartido"
      classType="card-adjuntos"
      title="Adjuntos"
      cardType="adjuntos"
      :data="adjuntos"
      :partidoId="partidoId"
      >
    </PartidoDataCard>
    <PartidoDataCard
      v-if="this.$store.state.permissions.canViewConsultas"
      classType="card-consultas"
      title="Consultas"
      cardType="consultas"
      :data="consultas"
      @createConsultaPartido="handleNewConsultaPartido"
      @ViewConsultaPartido="handleViewConsultaPartido"
      >
    </PartidoDataCard>
     <PartidoDataCard
      v-if="this.$store.state.permissions.canViewAllChatsFromSic ? true : (this.$store.state.permissions.canViewChatPartidos && partido.perteneceAlChat)"
      classType="card-chat"
      title="Chat"
      cardType="chat"
      :localData="partido.localLogo"
      :visitorData="partido.visitorLogo"
      :partidoId="partidoId"
      :data="[]"
      @ViewChat="handleViewChat"
      :partidoDescription="partido.description"
      :mensajes="mensajes"
      :puede-hablar="partido.perteneceAlChat"
      >
    </PartidoDataCard>
    <ConsultaPartidoCreatePopUp
     ref="creacionConsultaPartido"
     :partidoDescription="partido.description"
     :partidoId="partido.id"
     >
    </ConsultaPartidoCreatePopUp>
    <ConsultaPartidoViewPopUp
      v-if="openConsulta"
      ref="detalleConsultaPartido"
      :consultaId="viewConsultaId"
      @closeConsultaPopUp="handlecloseConsultaPopUp"
    >
    </ConsultaPartidoViewPopUp>
    <ComentarioPrePartidoCreatePopUp
     ref="creacionComentarioPrePartido"
     :partidoDescription="partido.description"
     :partidoId="partido.id"
     :tabActiva="tabActiva"
     :nombreTabActiva="nombreClubTabActiva"
     >
    </ComentarioPrePartidoCreatePopUp>
    <ComentarioPrePartidoViewPopUp
      v-if="openComentario"
      ref="detalleComentarioPrePartido"
      :comentarioId="viewComentarioId"
      @closeComentarioPopUp="handlecloseComentarioPopUp"
      :tabActiva="tabActiva"
    >
    </ComentarioPrePartidoViewPopUp>
    <ChatViewPopUp
      v-if="openChat"
      ref="detalleChat"
      :chatId="viewChatId"
      @closeChatPopUp="handleCloseChat"
      :mensajes="mensajes"
      :partido-description="partido.description"
      :partido-torneo="partido.tournamentName"
      :partido-fecha="partido.fechaName"
      :partido-date="partido.dateRealization"
    >
    </ChatViewPopUp>
    </v-content>
  </div>
</template>

<script>
import HeaderFichaPartido from '../components/HeaderFichaPartido.vue'
import EditCampoPartido from '../components/EditCampoPartido.vue'
import PartidoDataCard from '../components/PartidoDataCard.vue'
import ConsultaPartidoCreatePopUp from '../components/ConsultaPartidoCreatePopUp.vue'
import ConsultaPartidoViewPopUp from '../components/ConsultaPartidoViewPopUp.vue'
import ComentarioPrePartidoCreatePopUp from '../components/ComentarioPrePartidoCreatePopUp.vue'
import ComentarioPrePartidoViewPopUp from '../components/ComentarioPrePartidoViewPopUp.vue'
import ChatViewPopUp from '../components/ChatViewPopUp.vue'

export default {
  data () {
    return {
      partido: null,
      editMode: null,
      editType: null,
      editTitle: null,
      time: null,
      date: null,
      informes: [],
      consultas: [],
      adjuntos: [],
      viewConsultaId: null,
      openConsulta: false,
      loading: null,
      viewComentarioId: null,
      openComentario: false,
      tabActiva: null,
      nombreClubTabActiva: null,
      openChat: false,
      mensajes: null
    }
  },
  components: {
    HeaderFichaPartido,
    EditCampoPartido,
    PartidoDataCard,
    ConsultaPartidoCreatePopUp,
    ConsultaPartidoViewPopUp,
    ComentarioPrePartidoCreatePopUp,
    ComentarioPrePartidoViewPopUp,
    ChatViewPopUp
  },
  props: {
    partidoId: null,
    routeSelection: null
  },
  methods: {
    fetchFichaPartido () {
      this.axios
        .get(`informe-auditoria/ficha-partido/${this.partidoId}`)
        .then(response => {
          if (this.$store.state.permissions.canViewConsultas) {
            this.fetchConsultasPartido()
          }
          this.loading = false
          this.partido = response.data
          this.informes = response.data.informes.map(informe => informe)
          this.adjuntos = response.data.assets.map(asset => asset)
          this.mensajes = response.data.mensajes
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchConsultasPartido () {
      this.axios
        .get(`consulta?match=${this.partidoId}`)
        .then(response => {
          this.consultas = response.data.results.map(consulta => consulta)
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    handleEditCard (prop) {
      this.editMode = prop.editMode
      this.editType = prop.editType
      this.editTitle = prop.editTitle
      this.getDateTime()
    },
    switchEditMode () {
      this.editMode === true ? this.editMode = false : this.editMode = true
    },
    getDateTime () {
      const datetime = this.partido.dateRealization.split(' ')
      this.date = datetime[0]
      const [dia, mes, anio] = this.date.split('/')
      this.date = `${anio}-${mes}-${dia}`
      this.time = datetime[1]
    },
    goBack () {
      this.$router.go(-1)
      // this.$router.push({ name: 'fichaDePartidoFiltered', params: { torneoId: this.partido.tournament, fechaId: this.partido.fecha } })
    },
    handleNewConsultaPartido () {
      this.$refs.creacionConsultaPartido.showDialog()
    },
    handleViewConsultaPartido (consultaPartido) {
      this.viewConsultaId = consultaPartido
      this.openConsulta = true
    },
    handlecloseConsultaPopUp () {
      this.openConsulta = false
    },
    handleNewComentarioPrePartido (tabActiva, nombreSeleccionado) {
      this.tabActiva = tabActiva
      this.nombreClubTabActiva = nombreSeleccionado
      this.$refs.creacionComentarioPrePartido.showDialog()
    },
    handleViewComentarioPrePartido (comentarioPartido, tabActiva) {
      this.viewComentarioId = comentarioPartido
      this.tabActiva = tabActiva
      this.openComentario = true
    },
    handleViewChat (chat, mensajes) {
      this.viewChatId = chat
      this.openChat = true
    },
    handlecloseComentarioPopUp () {
      this.openComentario = false
    },
    handleCloseChat (chat, tabActiva) {
      this.openChat = false
    }
  },
  created () {
    this.loading = true
    this.fetchFichaPartido()
  }
}

</script>

<style scoped>
.toolbar-element {
  background: linear-gradient(#e2e2e2, #cbd1db);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12) !important;
}

.toolbar-title {
  font-size: 2.2em;
  font-family: SourceSansProLight, sans-serif;
  color: #293968;
}

.spacing-top {
  margin-top: 5.2em !important;
}

.body-content {
  background-color: white;
  min-height: 80em;
  padding: 0 0 3em 0 !important;
  margin: 8em 6em 0 6em !important;
}

.title {
  width: 100%;
  height: 60px;
  background-color: #293968;
  border-bottom: 8px solid #0bbad9;
  display: flex;
  justify-content: start;
  align-items: end;
}

.clubs-title {
  color: white;
  font-size: 1.5em;
  padding-left: 15px;
  padding-bottom: 5px;
  font-weight: 400;
}

</style>
